// extracted by mini-css-extract-plugin
export default {"table":"performance-table_table__vM0vr","table-header":"performance-table_table-header__C4lHw","table-row":"performance-table_table-row__sGcJp"};